import {useTranslation} from 'react-i18next';

import {TotalPrice, ConfirmModal} from 'components';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.CHARGEBEE_PAYMENT.CONFIRM_PAYMENT_MODAL;

type Props = {
    open: boolean;
    maxUsers?: number;
    unitPrice?: number;
    currency?: string;
    periodUnit?: string;
    onClose: (confirm: boolean) => void;
}

export const ConfirmPaymentModal: React.FC<Props> = ({open, maxUsers, unitPrice, currency, periodUnit, onClose}) => {
    const {t} = useTranslation();
    return (
        <ConfirmModal title={t(T_KEYS.TITLE)} open={open} onClose={onClose}>
            <div className='tw-ts-h5'>{t(T_KEYS.DESCRIPTION)}</div>
            {open &&
                <TotalPrice
                    className='tw-mt-4 tw-text-lg tw-text-center'
                    unitPrice={unitPrice}
                    maxUsers={maxUsers}
                    periodUnit={periodUnit}
                    currency={currency}
                />}
        </ConfirmModal>
    );
};